import { render } from "./StacksScreen.vue?vue&type=template&id=db356fd2"
import script from "./StacksScreen.vue?vue&type=script&lang=js"
export * from "./StacksScreen.vue?vue&type=script&lang=js"
script.render = render

export default script